export default "__VITE_ASSET__BsNAYECw__"